// Utility function to determine sorting field and direction from react-table sorting state
export default function determineSorting(sorting) {
  if (!sorting || sorting.length === 0) {
    return { sortField: null, sortDirection: null };
  }
  const sortField = sorting[0].id;
  const sortDirection = sorting[0].desc ? "desc" : "asc";
  return { sortField, sortDirection };
}
